<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Service Agreement Version"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
        <div *ngIf="!loading">
            <div class="service_aggreementBox">
                <div class="flex">
                    <p>Service Agreement Version: </p> <b>{{agreementVersionDetails?.serviceAgreementVersion}}</b>
                </div>
                <div class="flex">
                    <p>Version Updated: </p> <b>{{agreementVersionDetails?.versionUpdated | date : 'MMM-dd-YYYY'}}</b>
                </div>
                <button mat-raised-button color="primary" routerLink="/settings/service-agreement/edit-service-agreement-version">Update</button>
            </div>
            
        </div>
        <div *ngIf="loading">
            <p>Loading...</p>
        </div>
    </fury-page-layout-content>
  </fury-page-layout>
  


